import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import type { ReasoningStepInfo } from "../../../services/reasoning-step.service";

@Component({
  selector: "lib-reasoning-step",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  templateUrl: "./reasoning-step.component.html",
  styleUrl: "./reasoning-step.component.scss",
})
export class ReasoningStepComponent {
  readonly stepInfo = input.required<ReasoningStepInfo>();

  /** True while the agent is still streaming this reasoning message. */
  readonly isStreaming = input<boolean>(false);
}
